(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useCallback, useState, useMemo, useEffect } from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import useKeyPress from "../../../../hooks/useKeyPress";
import useQueryParams from "../../../../hooks/useQueryParams";
import CountryFlag from "../../../../components/CountryFlag";
import OutsideClick from "../../../../components/OutsideClick";
import styles from "./SearchHistory.module.css";
const MAX_PER_PAGE = 10;
const countryLabel = {
  bj: "Benin",
  ng: "Nigeria",
  aj: "Ajman",
  bh: "Bahrain",
  cg: "Congo",
  gn: "Guinea",
  et: "Ethiopia",
  ad: "Abu Dhabi",
  am: "Armenia"
};

const useCursorHandlers = _ref => {
  let {
    items,
    hovered,
    cursor,
    setCursor,
    onSubmit,
    onClose
  } = _ref;
  const downPress = useKeyPress("ArrowDown");
  const upPress = useKeyPress("ArrowUp");
  const enterPress = useKeyPress("Enter");
  useEffect(() => {
    if (items.length && downPress) {
      setCursor(prevState => prevState < items.length - 1 ? prevState + 1 : prevState);
    }
  }, [downPress, items.length, setCursor]);
  useEffect(() => {
    if (items.length && upPress) {
      setCursor(prevState => prevState > 0 ? prevState - 1 : prevState);
    }
  }, [items.length, setCursor, upPress]);
  useEffect(() => {
    if (enterPress) {
      if (items.length && cursor >= 0) {
        onSubmit(items[cursor]);
      } else {
        onClose();
      }
    }
  }, [cursor, enterPress, items, items.length, onClose, onSubmit]);
  useEffect(() => {
    if (items.length && hovered) {
      setCursor(items.indexOf(hovered));
    }
  }, [hovered, items, setCursor]);
};

__signature__(useCursorHandlers, "useKeyPress{downPress}\nuseKeyPress{upPress}\nuseKeyPress{enterPress}\nuseEffect{}\nuseEffect{}\nuseEffect{}\nuseEffect{}", () => [useKeyPress, useKeyPress, useKeyPress]);

const SearchHistory = /*#__PURE__*/React.memo(__signature__(_ref2 => {
  let {
    history,
    withCountry,
    onClose,
    onSearch
  } = _ref2;
  const [, setQueryParams] = useQueryParams();
  const {
    t
  } = useTranslation();
  const [cursor, setCursor] = useState(-1);
  const [hovered, setHovered] = useState(undefined);
  const items = useMemo(() => history.slice(0, MAX_PER_PAGE), [history]);
  const onSubmit = useCallback(_ref3 => {
    let {
      query,
      country
    } = _ref3;
    setQueryParams({
      q: query,
      country
    });
    onSearch({
      query,
      country
    });
    onClose();
  }, [onClose, onSearch, setQueryParams]);
  const onClick = useCallback(item => () => onSubmit(item), [onSubmit]);
  useCursorHandlers({
    items,
    cursor,
    hovered,
    setCursor,
    onSubmit,
    onClose
  }); // eslint-disable-next-line

  const onMouseEnter = useCallback(item => () => setHovered(item)); // eslint-disable-next-line

  const onMouseLeave = useCallback(() => setHovered(undefined));
  return /*#__PURE__*/React.createElement(OutsideClick, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.historyContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, t("Recent searches")), /*#__PURE__*/React.createElement("ul", {
    className: styles.list
  }, items === null || items === void 0 ? void 0 : items.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: item.query + item.country,
    className: cx(styles.listItem, {
      [styles.activeItem]: cursor === index
    }),
    onClick: onClick(item),
    onMouseEnter: onMouseEnter(item),
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.queryString
  }, item.query), withCountry && /*#__PURE__*/React.createElement("div", {
    className: styles.country
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(CountryFlag, {
    code: item.country,
    className: styles.flag
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.countryName
  }, countryLabel[item.country]))))))));
}, "useQueryParams{[, setQueryParams]}\nuseTranslation{{ t }}\nuseState{[cursor, setCursor](-1)}\nuseState{[hovered, setHovered](undefined)}\nuseMemo{items}\nuseCallback{onSubmit}\nuseCallback{onClick}\nuseCursorHandlers{}\nuseCallback{onMouseEnter}\nuseCallback{onMouseLeave}", () => [useQueryParams, useTranslation, useCursorHandlers]));
SearchHistory.displayName = "SearchHistory";
SearchHistory.propTypes = {
  history: PropTypes.array.isRequired,
  withCountry: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired
};
const _default = SearchHistory;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(MAX_PER_PAGE, "MAX_PER_PAGE", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SearchHistory/SearchHistory.jsx");
  reactHotLoader.register(countryLabel, "countryLabel", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SearchHistory/SearchHistory.jsx");
  reactHotLoader.register(useCursorHandlers, "useCursorHandlers", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SearchHistory/SearchHistory.jsx");
  reactHotLoader.register(SearchHistory, "SearchHistory", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SearchHistory/SearchHistory.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SearchHistory/SearchHistory.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();